export default {
  empty: 'Für diese Charge wurde kein Verbrauch erfasst.',
};
